import TabTaxAuthority from './TabTaxAuthority-redux';

export default TabTaxAuthority;
